/* ============================================================
   LYNEA360 — Theme JS
   Estratto da lynea360.html + Cart API Shopify
============================================================ */

// === CART (Shopify Cart API) ===

async function addToCart(variantId, qty = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  });
  const data = await res.json();
  await updateCartDrawer();
  openCart();
  return data;
}

async function updateCartDrawer() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  // Aggiorna badge contatore
  document.querySelectorAll('.cart-badge').forEach(b => {
    b.textContent = cart.item_count;
    b.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  renderCartItems(cart);

  const subtotalEl = document.querySelector('#cartTotal');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  const shipEl = document.querySelector('#cartShipNote');
  if (shipEl) {
    const freeThreshold = 4900; // €49 in centesimi
    if (cart.total_price < freeThreshold) {
      const diff = formatMoney(freeThreshold - cart.total_price);
      shipEl.innerHTML = `Aggiungi <strong>${diff}</strong> per la spedizione gratuita`;
    } else {
      shipEl.innerHTML = '<strong>Spedizione gratuita</strong> inclusa';
    }
  }
}

function renderCartItems(cart) {
  const el = document.getElementById('cartItems');
  const footer = document.getElementById('cartFooter');
  if (!el) return;

  if (cart.item_count === 0) {
    el.innerHTML = `
      <div class="cart-empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
        <p>Il carrello è vuoto</p>
      </div>`;
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = 'block';

  el.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-img">
        ${item.image
          ? `<img src="${item.image}" alt="${item.product_title}" style="width:100%;height:100%;object-fit:cover;">`
          : `<div class="img-placeholder" style="height:100%"></div>`}
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Diminuisci quantità">−</button>
          <span>${item.quantity}</span>
          <button class="qty-btn" data-key="${item.key}" data-delta="1" aria-label="Aumenta quantità">+</button>
        </div>
      </div>
      <span class="cart-item-price">${formatMoney(item.line_price)}</span>
      <button class="cart-remove" data-key="${item.key}" aria-label="Rimuovi ${item.product_title}">×</button>
    </div>`).join('');

  // Qty buttons
  el.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta);
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      const newQty = Math.max(0, item.quantity + delta);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      await updateCartDrawer();
    });
  });

  // Remove buttons
  el.querySelectorAll('.cart-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      });
      await updateCartDrawer();
    });
  });
}

function formatMoney(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

// === CART DRAWER UI ===

function openCart() {
  document.getElementById('cartSidebar').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartOverlay').setAttribute('aria-hidden', 'false');
  const trigger = document.getElementById('cartOpen');
  if (trigger) trigger.setAttribute('aria-expanded', 'true');
  updateCartDrawer();
}

function closeCart() {
  document.getElementById('cartSidebar').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartOverlay').setAttribute('aria-hidden', 'true');
  const trigger = document.getElementById('cartOpen');
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
}

document.addEventListener('DOMContentLoaded', () => {

  // Cart triggers
  const cartOpen = document.getElementById('cartOpen');
  const cartClose = document.getElementById('cartClose');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartContinue = document.getElementById('cartContinue');

  if (cartOpen) cartOpen.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartContinue) cartContinue.addEventListener('click', closeCart);

  // Checkout
  const checkoutBtn = document.querySelector('.cart-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  // Add to cart buttons
  document.querySelectorAll('.add-to-cart').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (variantId) addToCart(variantId, 1);
    });
  });

  // Init — aggiorna badge al caricamento
  updateCartDrawer().catch(() => {});

  // === NAV ===

  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open);
    });
    document.querySelectorAll('.mobile-link').forEach(l => {
      l.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Nav scroll effect
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background =
        window.scrollY > 60 ? 'rgba(10,10,11,0.97)' : 'rgba(10,10,11,0.85)';
    }, { passive: true });
  }

  // === LANG SWITCHER ===

  document.querySelectorAll('.lang-switcher button').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.lang-switcher button').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  // === FAQ ACCORDION ===

  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

});
